import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { calculateDistance, getInlineLoader } from "../Helpers";
import {
	STR_ALL2,
	STR_AVAILABLE_HOTELS,
	STR_CHANGE_PHONE_NUMBER,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_MENU_HOTELS,
	STR_NEARBY_HOTELS,
	STR_NEARBY_LODGES,
	STR_NO_HOTEL_WAS_FOUND,
	STR_NO_RECORD,
	STR_NOTIFICATIONS,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_SEARCH_HERE,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdContactPage, MdInfoOutline, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdSearch, MdSupportAgent, MdTranslate } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import OneHotelFeed from '../ones/OneHotelFeed';
import WelcomeSlider from "../ones/WelcomeSlider";
import UserLocationPin from "../ones/UserLocationPin";


export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [selectedAttribute, setSelectedAttribute] = useState(null);
	const [filter, setFilter] = useState('');
	const [lodgesList, setLodgesList] = useState([]);

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getLodgesFeed(),
			appContext.getAllHotelAttributes(),
		]);
		setReady(true);
	}

	function processFeed() {
		const _list = [];

		function calculateHotelDistance(hotelData) {
			if (
				hotelData &&
				appContext.currentLocation &&
				appContext.currentLocation.lat &&
				appContext.currentLocation.lng
			) {
				const _distance = calculateDistance(appContext.currentLocation, JSON.parse(hotelData.location));
				return _distance;
			}
			return null;
		}

		const normalizedFilter = filter.trim().toLowerCase();

		if (appContext.lodgesFeed) {
			for (const _hotel of appContext.lodgesFeed) {
				_hotel.distance = calculateHotelDistance(_hotel);

				// Filter by attribute
				if (selectedAttribute) {
					const _hotelFeatures = JSON.parse(_hotel.features || '[]');
					const hasFeature = _hotelFeatures.some(
						(featureId) => Number(selectedAttribute.id) === Number(featureId)
					);
					if (!hasFeature) continue;
				}

				// Filter by text (name or description)
				if (normalizedFilter) {
					const name = (_hotel.name || '').toLowerCase();
					const description = (_hotel.description || '').toLowerCase();

					if (!name.includes(normalizedFilter) && !description.includes(normalizedFilter)) {
						continue;
					}
				}

				_list.push(_hotel);
			}
		}

		// Sort by distance (ascending)
		_list.sort((a, b) => {
			if (a.distance === null || a.distance === undefined) return 1;
			if (b.distance === null || b.distance === undefined) return -1;
			return a.distance - b.distance;
		});

		setLodgesList(_list);
	}



	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		processFeed()
	}, [ appContext.lodgesFeed, appContext.currentLocation, selectedAttribute, filter ])

	if (ready) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingTop: "20px",
					paddingBottom: "calc(var(--topBarHeight) + 40px)",
				}}
				className="mNoScrollBar"
			>
				<div className="container">

					<div className="row">
						
						<div className="col-md-12">
							<WelcomeSlider/>
						</div>

						<div className="col-md-12 mt-2">
							<UserLocationPin/>
						</div>

						<div className="col-md-12 mt-4" id="_lodgesList">
							<h6
								className="main-section-title"
							>
								{STR_NEARBY_LODGES[appContext.language]}
							</h6>
						</div>

						<div className="col-md-12 mt-2 mb-4">
							
							<div 
								className="d-flex mNoScrollBar"
								style={{
									overflowX: "none",
									whiteSpace: "nowrap",
									flexWrap: 'wrap',
									width: "100%",
									
								}}
							>
								<span
									className={!(selectedAttribute) ? "categoryBtn bg-primary" : "categoryBtn"}
									onClick={() => {
										setSelectedAttribute(null);
										try {
											document.getElementById('_lodgesList').scrollIntoView({ behavior: 'smooth' })
										} catch (error) {
											
										}
									}}
								>
									{STR_ALL2[appContext.language]}
								</span>
	
								{
									(appContext.allHotelAttributes && appContext.allHotelAttributes.length > 0) ?
									appContext.allHotelAttributes.map((item, i) => {

										const _catUi = (
											<span
												className={(selectedAttribute && (Number(selectedAttribute.id) === Number(item.id))) ? "categoryBtn bg-primary" : "categoryBtn"}
												key={i}
												onClick={() => {
													setSelectedAttribute(item);
													try {
														document.getElementById('_lodgesList').scrollIntoView({ behavior: 'smooth' })
													} catch (error) {
														
													}
												}}
											>
												{(appContext.language === 'sw') ? item.nameSw : ""}
												{(appContext.language === 'en') ? item.nameEn : ""}
											</span>
										)
										
										return _catUi;
									})
									:""
								}
							</div>
							
						</div>

						<div className="col-md-12">
							<div className="d-flex mt-1 mb-4">
								<MdSearch
									style={{
										flexShrink: 0,
									}}
									size={28}
									className="align-self-center"
								/>

								<input
									className="form-control flex-grow-1 align-self-center"
									placeholder={STR_SEARCH_HERE[appContext.language]}
									onChange={(e) => setFilter(e.target.value)}
									value={filter}
								/>
							</div>
						</div>

						{
							(lodgesList && lodgesList.length > 0) ?
							lodgesList.map((item, i) => {
								return (
									<div className="col-md-6" key={i}>
										<OneHotelFeed data={item}/>
									</div>
								)
							})
							:
							<div className="col-md-12">
								<h6>{STR_NO_HOTEL_WAS_FOUND[appContext.language]}</h6>
							</div>
						}
					</div>

					

				</div>


			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}